import { useQuery } from '@apollo/client';
import { UserContext } from '@providers/userContextProvider';
import { generateClientNameString } from '@utils/generateClientNameString';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { usePermission } from '../../hooks/usePermission';
import { FETCH_USER_NAME } from './clientBreadcrumb.query';

export function ClientBreadcrumb() {
  const { t } = useTranslation();
  const canReadClientLowRiskPii = usePermission('read:client_low_risk_pii');
  const { userId: paramsUserId } = useParams();
  const { activeEntity } = useContext(UserContext);

  const userId = paramsUserId ?? activeEntity?.id;
  const { data } = useQuery(FETCH_USER_NAME({ canReadClientLowRiskPii }), {
    variables: { userId },
  });

  return data
    ? generateClientNameString(data.fetchUser?.user)
    : t('client:client');
}
